import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7gu2z523yj: FaireBrandEntity = {
  token: "b_7gu2z523yj",
  type: "brand",
  name: "P&PD Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/ded3a8e251813771a801e21e743af064f2dfb79806e53dda3a349426b73f52ca.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d065cb2c663a56683a6bb75005429efe1ab308ebb43f1cc68783a09bff3f692e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ded3a8e251813771a801e21e743af064f2dfb79806e53dda3a349426b73f52ca.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d065cb2c663a56683a6bb75005429efe1ab308ebb43f1cc68783a09bff3f692e.png",
  location: "GRAND SALINE, TX, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 680,
  isInsider: true,
  description:
    "Hi!  My name is Ashley Vail and I am the owner of Pearls & Paper Dolls.  Me and my husband started this business with a newborn baby girl in a tiny office in the back of my father's tanning salon in 2016. I have expanded and expanded ever since!  Since we have opened, I have worked with thousands of boutiques across the US and I would love the honor of working with you too!! Let's connect <3",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:48.676Z",
    importedBy: "entity-db-cli",
  },
};
